export default __webpack_public_path__ + "static/media/007-diamond.d9328e48.svg";